module.exports = __webpack_public_path__ + "img/dollar-seedling-growth.9ecc319d.png";